/**
 *
 * LoanableFilter
 *
 */
import { CampusPicker } from 'app/components/pickers/AutocompletePickers/CampusPicker';
import * as React from 'react';
import { translations } from 'locales/translations';
import { useTranslation } from 'react-i18next';
import { Entity } from 'types/common';
import { IFilterComponentProps } from '../IFilterComponentProps';

export const CampusFilter = (props: IFilterComponentProps) => {
  const handleOnChange = (value: Entity<number> | null) => {
    props.onChange(value);
  };
  const { t } = useTranslation();
  return (
    <CampusPicker
      onChange={handleOnChange}
      value={props.value}
      isOpen={props.open}
      size="small"
      placeholder={t(translations.AllValues)}
      ariaLabel={props.label}
      id={props.id}
      predicates={props.predicates}
      onPickerOpen={props.onOpen}
      urlType={props.urlType}
      withoutServiceGroups={props.withoutServiceGroups}
    />
  );
};

export default CampusFilter;
